import type { TabConfig } from "./NavigationTabs";
import type { Variants } from "framer-motion";

export const TAB_CONFIG: TabConfig[] = [
  {
    id: "tab-community-growth",
    labelKey: "community_growth",
    sectionId: "community-growth",
  },
  {
    id: "tab-member-engagement",
    labelKey: "member_engagement",
    sectionId: "member-engagement",
  },
  {
    id: "tab-content-and-experience",
    labelKey: "content_and_experience",
    sectionId: "content-and-experience",
  },
  {
    id: "tab-business-impact",
    labelKey: "business_impact",
    sectionId: "business-impact",
  },
  {
    id: "tab-email-highlights",
    labelKey: "email_highlights",
    sectionId: "email-highlights",
  },
  {
    id: "tab-automation-and-efficiency",
    labelKey: "automation_and_efficiency",
    sectionId: "automation-and-efficiency",
  },
];

export const STAGGER_CHILDREN = 0.05;
export const DELAY_CHILDREN = 0.1;

export const SCROLL_THRESHOLD = 20;
export const SCROLL_LOCK_DURATION = 1000;
export const MIN_VISIBILITY_THRESHOLD = 0.1;

export const containerVariants: Variants = {
  hidden: { opacity: 0, y: -20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
      staggerChildren: STAGGER_CHILDREN,
      delayChildren: DELAY_CHILDREN,
    },
  },
};

export const tabVariants: Variants = {
  hidden: { opacity: 0, y: -20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

export const activeTabSpring = {
  type: "spring" as const,
  stiffness: 380,
  damping: 30,
};

export const navVariants: Variants = {
  default: {
    backgroundColor: "rgba(255, 255, 255, 0)",
    borderColor: "rgba(255, 255, 255, 0)",
    backdropFilter: "blur(0px)",
  },
  scrolled: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    borderColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(16px)",
    transition: {
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};
